<template>
  <div class="punchboard-container">
    <!-- 透明蓋板和播放按鈕 -->
    <div v-if="showStartOverlay" id="start-overlay" class="start-overlay">
      <div class="start-button" @click="startGame">
        <div class="play-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 24 24" fill="white">
            <path d="M8 5v14l11-7z"/>
          </svg>
        </div>
      </div>
      <!-- 設定按鈕 -->
      <button id="setting-button-overlay" class="setting-button-overlay" @click="goToSettings">
        <svg-icon icon-class="setting-game" class="setting-icon" />
      </button>
    </div>
    
    <!-- 卡片結果彈窗 -->
    <div v-if="showCardResultPopup" id="card-result-popup" class="card-result-popup show" @click="closeCardResult">
      <div class="card-result-content">
        <div class="close-button" @click="closeCardResult">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        <div id="card-result">
          <div class="result-card">
            <!-- 顯示成員頭像 -->
            <img v-if="selectedItem && selectedItem.avatar && pickupData && pickupData.pickupType === 'Client'" 
                 :src="selectedItem.avatar" 
                 class="result-avatar" 
                 :alt="selectedItem.memberName">
            
            <!-- 顯示座位ID -->
            <div v-if="selectedItem && selectedItem.seatID && pickupData && pickupData.pickupType === 'Client'" 
                 class="result-seat-id">
              {{ selectedItem.seatID }}
            </div>

            
            
            <!-- 顯示成員名稱 -->
            <div v-if="selectedItem && selectedItem.memberName && pickupData && pickupData.pickupType === 'Client'" 
                 class="result-card-name">
              {{ selectedItem.memberName }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="punch-board" id="punch-board" ref="punchBoard">
        <!-- Cards will be generated here -->
        <div 
          v-for="(item, index) in displayItems" 
          :key="index"
          class="punch-hole"
          :class="{ 'punched': punchedItems.includes(index), 'punching': punchingItems.includes(index) }"
          @click="punchHole(index, item)"
        >
          <!-- 戳洞內容 -->
          <div class="punch-content">
            <!-- 顯示成員頭像 -->
            <img v-if="item.avatar && pickupData && pickupData.pickupType === 'Client'" 
                 :src="item.avatar" 
                 class="avatar" 
                 :alt="item.memberName">
            
            <!-- 顯示座位ID -->
            <div v-if="item.seatID && pickupData && pickupData.pickupType === 'Client'" 
                 class="seat-id">
              {{ item.seatID }}
            </div>

            <!-- 創建結果信息容器 -->
            <div class="result-info">
              <!-- 顯示成員名稱或組別名稱 -->
              <div v-if="pickupData && pickupData.pickupType === 'Client'" 
                   class="result-name">
                {{ item.memberName }}
              </div>
            </div>
          </div>

          <!-- 戳洞表面 -->
          <div class="punch-cover" :style="{ backgroundColor: item.coverColor }"></div>

          <!-- 戳洞效果 -->
          <div class="punch-effect"></div>
        </div>
      </div>

      <!-- 右上角按鈕群組 -->
      <div class="top-right-buttons">

        <!-- 重置按鈕 -->
        <button id="reset-button" class="top-button reset-button" @click="resetGame">
          <svg width="28px" height="28px" viewBox="0 0 1920 1920" fill="#000000">
            <path d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0" fill-rule="evenodd" />
          </svg>
        </button>

        <!-- 設定按鈕 -->
        <button id="setting-button" class="top-button setting-button" @click="goToSettings">
          <svg-icon icon-class="setting-game" class="setting-icon" />
        </button>
      </div>
    </div>

    <!-- 音效元素 -->
    <audio ref="punchSound" preload="auto">
      <source src="@/assets/HTwbActAssets/gameSounds/punch-4-84743.mp3" type="audio/mpeg">
    </audio>
    <audio ref="winSound" preload="auto">
      <source src="@/assets/HTwbActAssets/gameSounds/success-fanfare-trumpets-6185.mp3" type="audio/mpeg">
    </audio>
    <audio ref="animationMusic" preload="auto">
      <source src="@/assets/HTwbActAssets/gameSounds/pixel-fight-8-bit-arcade-music-background-music-for-video-208775.mp3" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'

// 導入頭像圖片
import pandaAvatar from '@/assets/Openclipart/animals_panda.png'
import catAvatar from '@/assets/Openclipart/animals_cat1.png'
import bearAvatar from '@/assets/Openclipart/animals_bear.png'
import foxAvatar from '@/assets/Openclipart/animals_fox.png'
import rabbitAvatar from '@/assets/Openclipart/animals_rabbit.png'
import monkeyAvatar from '@/assets/Openclipart/animals_monkey.png'
import lionAvatar from '@/assets/Openclipart/animals_lion.png'
import tigerAvatar from '@/assets/Openclipart/animals_tiger.png'
import elephantAvatar from '@/assets/Openclipart/animals_elephant.png'
import penguinAvatar from '@/assets/Openclipart/animals_penguin.png'
import SvgIcon from '@/components/SvgIcon.vue'

export default {
  name: 'HTPunchBoardPlay',
  components: {
    SvgIcon
  },
  setup() {
    // 響應式數據
    const showStartOverlay = ref(true)
    const showCardResultPopup = ref(false)
    const gameStarted = ref(false)
    const isAnimationMusicPlaying = ref(false)
    const selectedItem = ref(null)
    const displayItems = ref([])
    const punchedItems = ref([])
    const punchingItems = ref([])
    
    // refs
    const punchBoard = ref(null)
    const punchSound = ref(null)
    const winSound = ref(null)
    const animationMusic = ref(null)

    // 遊戲數據
    const pickupData = ref({
      pickupType: "Client",
      memberList: []
    })
    const allCandidatesCache = ref([])
    let colorIntervals = []

    // 頭像陣列
    const avatars = [pandaAvatar, catAvatar, bearAvatar, foxAvatar, rabbitAvatar, 
                    monkeyAvatar, lionAvatar, tigerAvatar, elephantAvatar, penguinAvatar]

    // 通信工具類
    const MessageBridge = {
      ENV: {
        WEBVIEW: 'webview',
        WEB: 'web'
      },
      currentEnv: 'web',
      init() {
        this.currentEnv = window.chrome?.webview ? this.ENV.WEBVIEW : this.ENV.WEB
        return this
      },
      postMessage(data, origin = '*') {
        if (this.currentEnv === this.ENV.WEBVIEW) {
          window.chrome.webview.postMessage(data)
        } else {
          window.postMessage(data, origin)
        }
      },
      addEventListener(callback) {
        if (this.currentEnv === this.ENV.WEBVIEW) {
          window.chrome.webview.addEventListener('message', event => {
            callback(event)
          })
        } else {
          window.addEventListener('message', event => {
            callback(event)
          })
        }
      }
    }

    const messageBridge = MessageBridge.init()

    // 工具函數
    const shuffleArray = (array) => {
      const newArray = [...array]
      for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]]
      }
      return newArray
    }

    // enrichMembersWithGroup 功能已註解，不再使用群組功能
    // const enrichMembersWithGroup = (data) => {
    //   const memberList = data.memberList
    //   const groupList = data.groupList || []

    //   const seatToGroupMap = {}
    //   groupList.forEach(group => {
    //     group.memberList.forEach(seatID => {
    //       seatToGroupMap[seatID] = {
    //         groupID: group.groupID,
    //         groupName: group.groupName
    //       }
    //     })
    //   })

    //   const enrichedMemberList = memberList.map(member => {
    //     const groupInfo = seatToGroupMap[member.seatID] || {
    //       groupID: "",
    //       groupName: ""
    //     }
    //     return Object.assign({}, member, groupInfo)
    //   })

    //   if (enrichedMemberList.length > 20) {
    //     const randomIndexes = []
    //     while (randomIndexes.length < 20) {
    //       const randomIndex = Math.floor(Math.random() * enrichedMemberList.length)
    //       if (!randomIndexes.includes(randomIndex)) {
    //         randomIndexes.push(randomIndex)
    //       }
    //     }
    //     const randomMembers = randomIndexes.map(index => enrichedMemberList[index])
    //     return randomMembers
    //   }

    //   return enrichedMemberList
    // }

    const getPickCandidates = () => {
      const pickupType = pickupData.value.pickupType
      let candidates = []

      switch (pickupType) {
        case 'Client':
          if (pickupData.value.memberList && pickupData.value.memberList.length > 0) {
            if (pickupData.value.isSmartPickup) {
              candidates = pickupData.value.memberList
                .filter(member => {
                  return pickupData.value.options.includes(member.seatID.toString())
                })
                .map(member => member)
            } else {
              candidates = pickupData.value.memberList.map(member => member)
            }
          }
          break

        // Group 和 General 模式已註解，只支援 Client 模式
        // case 'Group':
        //   if (pickupData.value.groupList && pickupData.value.groupList.length > 0) {
        //     if (pickupData.value.isSmartPickup) {
        //       candidates = pickupData.value.groupList
        //         .filter(group => {
        //           return pickupData.value.options.includes(group.groupID)
        //         })
        //         .map(group => group)
        //     } else {
        //       candidates = pickupData.value.groupList.map(group => group)
        //     }
        //   }
        //   break

        // case 'General':
        //   if (pickupData.value.options && pickupData.value.options.length > 0) {
        //     candidates = pickupData.value.options.map(option => ({
        //       name: option
        //     }))
        //   }
        //   break
      }
      return candidates
    }

    // 創建假的洞洞背板
    const createFakePunchBoard = () => {
      const fakeItems = []
      for (let i = 0; i < 20; i++) {
        const r = Math.floor(Math.random() * 256)
        const g = Math.floor(Math.random() * 256)
        const b = Math.floor(Math.random() * 256)
        fakeItems.push({
          coverColor: `rgba(${r}, ${g}, ${b}, 1)`,
          fake: true
        })
      }
      displayItems.value = fakeItems
    }

    // 創建真正的戳洞板
    const createPunchBoard = (data) => {
      if (!gameStarted.value) {
        return
      }

      // 清除之前的顏色動畫
      colorIntervals.forEach(interval => clearInterval(interval))
      colorIntervals = []

      // 重置狀態
      punchedItems.value = []
      punchingItems.value = []
      isAnimationMusicPlaying.value = false
      
      if (animationMusic.value && !animationMusic.value.paused) {
        animationMusic.value.pause()
        animationMusic.value.currentTime = 0
      }

      // 隨機打亂順序
      const shuffledItems = shuffleArray(data)

      // 開始播放動畫音樂
      if (!isAnimationMusicPlaying.value) {
        isAnimationMusicPlaying.value = true
        setTimeout(() => {
          if (animationMusic.value) {
            animationMusic.value.currentTime = 0
            animationMusic.value.play().catch(error => {
              console.log('播放動畫音樂失敗:', error)
              isAnimationMusicPlaying.value = false
            })
          }
        }, 100)
      }

      // 為每個項目添加初始顏色和設置動畫
      const itemsWithColor = shuffledItems.map((item, index) => {
        const itemWithColor = {
          ...item,
          coverColor: `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)`
        }

        // 開始3秒連續亂數換顏色動畫
        const animationDuration = 3000
        const startTime = Date.now()
        
        const colorInterval = setInterval(() => {
          const elapsed = Date.now() - startTime
          if (elapsed < animationDuration) {
            const r = Math.floor(Math.random() * 256)
            const g = Math.floor(Math.random() * 256)
            const b = Math.floor(Math.random() * 256)
            
            // 直接更新 displayItems 中對應項目的顏色
            const newItems = [...displayItems.value]
            if (newItems[index]) {
              newItems[index].coverColor = `rgba(${r}, ${g}, ${b}, 1)`
              displayItems.value = newItems
            }
          } else {
            clearInterval(colorInterval)
            const r = Math.floor(Math.random() * 256)
            const g = Math.floor(Math.random() * 256)
            const b = Math.floor(Math.random() * 256)
            
            // 最終顏色設定
            const newItems = [...displayItems.value]
            if (newItems[index]) {
              newItems[index].coverColor = `rgba(${r}, ${g}, ${b}, 1)`
              displayItems.value = newItems
            }
            
            // 檢查是否所有動畫都結束，如果是則停止音樂
            if (index === shuffledItems.length - 1) {
              setTimeout(() => {
                if (animationMusic.value && !animationMusic.value.paused) {
                  animationMusic.value.pause()
                }
                isAnimationMusicPlaying.value = false
              }, 200)
            }
          }
        }, 100)

        colorIntervals.push(colorInterval)
        return itemWithColor
      })

      displayItems.value = itemsWithColor
    }

    // 創建裂紋效果
    const createCracks = (element) => {
      const rect = element.getBoundingClientRect()
      const centerX = rect.width / 2
      const centerY = rect.height / 2

      const crackCount = 8
      for (let i = 0; i < crackCount; i++) {
        const crack = document.createElement('div')
        crack.className = 'crack'

        const angle = (i / crackCount) * 360
        crack.style.width = '0'
        crack.style.height = '2px'
        crack.style.position = 'absolute'
        crack.style.top = `${centerY}px`
        crack.style.left = `${centerX}px`
        crack.style.transformOrigin = '0 0'
        crack.style.transform = `rotate(${angle}deg)`
        crack.style.backgroundColor = 'rgba(255, 255, 255, 0.8)'
        crack.style.boxShadow = '0 0 5px rgba(255, 255, 255, 0.8)'
        crack.style.zIndex = '4'
        crack.style.animation = `crackAnimation 0.3s ease-out ${i * 0.05}s forwards`

        element.appendChild(crack)
      }
    }

    // 創建紙屑效果
    const createConfetti = (element) => {
      const rect = element.getBoundingClientRect()
      const centerX = rect.width / 2
      const centerY = rect.height / 2

      for (let i = 0; i < 30; i++) {
        const confetti = document.createElement('div')
        confetti.className = `confetti confetti-${Math.floor(Math.random() * 4) + 1}`

        const size = 5 + Math.random() * 10
        confetti.style.width = `${size}px`
        confetti.style.height = `${size}px`

        if (Math.random() > 0.5) {
          confetti.style.borderRadius = '50%'
        } else {
          confetti.style.borderRadius = `${Math.random() * 4}px`
        }

        const angle = Math.random() * Math.PI * 2
        const distance = 40 + Math.random() * 80
        const tx = Math.cos(angle) * distance
        const ty = Math.sin(angle) * distance
        const rot = Math.random() * 720 - 360

        confetti.style.setProperty('--tx', `${tx}px`)
        confetti.style.setProperty('--ty', `${ty}px`)
        confetti.style.setProperty('--rot', `${rot}deg`)

        confetti.style.left = `${centerX}px`
        confetti.style.top = `${centerY}px`

        const delay = Math.random() * 0.2
        confetti.style.animation = `confettiAnimation 1.5s ease-out ${delay}s forwards`

        element.appendChild(confetti)

        setTimeout(() => {
          confetti.remove()
        }, 1500 + delay * 1000)
      }
    }

    // 事件處理函數
    const startGame = () => {
      // 發送遊戲開始協議給 WebView
      messageBridge.postMessage({
        action: "Game.Start",
        type: "punchboard"
      });

      // 嘗試播放音效來初始化音頻上下文
      const audioElements = [punchSound.value, winSound.value, animationMusic.value]

      audioElements.forEach(audio => {
        if (audio) {
          audio.muted = true
          audio.play().then(() => {
            audio.muted = false
            audio.pause()
            audio.currentTime = 0
          }).catch(e => console.log('音效初始化失敗:', e))
        }
      })

      showStartOverlay.value = false
      gameStarted.value = true
      
      if (pickupData.value) {
        allCandidatesCache.value = getPickCandidates()
        createPunchBoard(allCandidatesCache.value)
      } else {
        console.log('等待遊戲數據...')
      }
    }

    const punchHole = (index, item) => {
      if (!punchedItems.value.includes(index) && !punchingItems.value.includes(index)) {
        // 添加戳洞動畫
        punchingItems.value.push(index)
        
        // 播放戳洞音效
        if (punchSound.value) {
          punchSound.value.currentTime = 0
          punchSound.value.play().catch(error => {
            console.log('播放戳洞音效失敗:', error)
          })
        }

        // 獲取DOM元素並創建效果
        nextTick(() => {
          const holeElement = document.querySelector(`.punch-hole:nth-child(${index + 1})`)
          if (holeElement) {
            createCracks(holeElement)
            createConfetti(holeElement)

            // 增加閃光效果
            const flash = document.createElement('div')
            flash.style.position = 'fixed'
            flash.style.top = '0'
            flash.style.left = '0'
            flash.style.width = '100%'
            flash.style.height = '100%'
            flash.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
            flash.style.zIndex = '9999'
            flash.style.pointerEvents = 'none'
            document.body.appendChild(flash)

            setTimeout(() => {
              flash.remove()
            }, 100)

            // 模擬裂開的震動效果
            const intensity = 5
            const duration = 500
            const startTime = Date.now()

            const shakeInterval = setInterval(() => {
              const elapsed = Date.now() - startTime
              if (elapsed < duration) {
                const factor = 1 - (elapsed / duration)
                const x = (Math.random() * 2 - 1) * intensity * factor
                const y = (Math.random() * 2 - 1) * intensity * factor
                holeElement.style.transform = `translate(${x}px, ${y}px)`
              } else {
                clearInterval(shakeInterval)
                holeElement.style.transform = ''
              }
            }, 20)
          }
        })

        // 延遲後添加已戳洞類
        setTimeout(() => {
          const punchingIndex = punchingItems.value.indexOf(index)
          if (punchingIndex > -1) {
            punchingItems.value.splice(punchingIndex, 1)
          }
          punchedItems.value.push(index)
          
          // 播放選中音效
          if (winSound.value) {
            winSound.value.currentTime = 0
            winSound.value.play().catch(error => {
              console.log('播放選中音效失敗:', error)
            })
          }
          
          // 顯示選中的卡片結果
          showCardResult(item)
        }, 500)

        // 發送挑選結果
        messageBridge.postMessage({
          action: 'Pickup.Result',
          pickupType: pickupData.value.pickupType,
          pickedList: [item.seatID] // 只使用 seatID，不再支援 groupID
        })

      } else if (punchedItems.value.includes(index)) {
        // 播放選中音效
        if (winSound.value) {
          winSound.value.currentTime = 0
          winSound.value.play().catch(error => {
            console.log('播放選中音效失敗:', error)
          })
        }
        
        // 顯示選中的卡片結果
        showCardResult(item)                  
      }
    }

    const showCardResult = (item) => {
      selectedItem.value = item
      showCardResultPopup.value = true
    }

    const closeCardResult = () => {
      showCardResultPopup.value = false
      
      // 停止win-sound音效
      if (winSound.value) {
        winSound.value.pause()
        winSound.value.currentTime = 0
      }
      
      selectedItem.value = null
    }


    const goToSettings = () => {
      // 清理資源
      colorIntervals.forEach(interval => clearInterval(interval))
      colorIntervals = []
      
      // 停止所有音效
      const audioElements = [punchSound.value, winSound.value, animationMusic.value]
      audioElements.forEach(audio => {
        if (audio && !audio.paused) {
          audio.pause()
          audio.currentTime = 0
        }
      })
      
      // 路由到設定頁面
      window.location.href = '/ht-punchboard-setting'
    }



    const resetGame = () => {
      if (pickupData.value) {
        allCandidatesCache.value = getPickCandidates()
        createPunchBoard(allCandidatesCache.value)
      }
    }

    // 設置訊息監聽器
    const setupMessageListener = () => {
      // 使用通信橋接器監聽來自外部的 Init.PunchBoard 訊息
      messageBridge.addEventListener((event) => {
        const msg = event.data
        console.log('收到訊息:', msg)
        if (msg.action === 'Init.PunchBoard') {
          handleInitMessage(msg)
          // 將設定存入 sessionStorage
          sessionStorage.setItem('PunchBoardConfig', JSON.stringify(msg.data))
        }
      })
    }

    // 發送初始化訊息
    const sendInitMessage = () => {
      messageBridge.postMessage({
        action: 'Init.PunchBoard',
        data: {
          pickupType: "Client",
          // isSmartPickup: false,
          memberList: [
            { seatID: 1, memberName: "Apple", pickedTimes: 11, avatar: "" },
            { seatID: 2, memberName: "Banana", pickedTimes: 1, avatar: "" },
            { seatID: 3, memberName: "Orange", pickedTimes: 11, avatar: "" },
            { seatID: 4, memberName: "Grape", pickedTimes: 0, avatar: "" },
            { seatID: 5, memberName: "Strawberry", pickedTimes: 10, avatar: "" },
            { seatID: 6, memberName: "Blueberry", pickedTimes: 5, avatar: "" },
            { seatID: 7, memberName: "Raspberry", pickedTimes: 7, avatar: "" },
            { seatID: 8, memberName: "Pineapple", pickedTimes: 12, avatar: "" },
            { seatID: 9, memberName: "Mango", pickedTimes: 15, avatar: "" },
            { seatID: 10, memberName: "Watermelon", pickedTimes: 1, avatar: "" },
            { seatID: 11, memberName: "Peach", pickedTimes: 0, avatar: "" },
            { seatID: 12, memberName: "Plum", pickedTimes: 0, avatar: "" },
            { seatID: 13, memberName: "Cherry", pickedTimes: 0, avatar: "" },
            { seatID: 14, memberName: "Lemon", pickedTimes: 0, avatar: "" },
            { seatID: 15, memberName: "Lime", pickedTimes: 0, avatar: "" },
            { seatID: 16, memberName: "Coconut", pickedTimes: 0, avatar: "" },
            { seatID: 17, memberName: "Kiwi", pickedTimes: 0, avatar: "" },
            { seatID: 18, memberName: "Avocado", pickedTimes: 0, avatar: "" },
            { seatID: 19, memberName: "Pomegranate", pickedTimes: 0, avatar: "" },
            { seatID: 20, memberName: "Papaya", pickedTimes: 0, avatar: "" }
          ]
          // groupList: [
          //   { groupID: "1", groupName: "Group_1", pickedTimes: 5, memberList: [1, 2, 3] },
          //   { groupID: "2", groupName: "Group_2", pickedTimes: 7, memberList: [4, 5] },
          //   { groupID: "3", groupName: "Group_3", pickedTimes: 0, memberList: [6, 7] },
          //   { groupID: "4", groupName: "Group_4", pickedTimes: 4, memberList: [8, 9, 10] }
          // ]
        }
      })
    }

    // 處理初始化訊息
    const handleInitMessage = (message) => {
      console.log('收到初始化訊息:', message)
      
      // 為沒有頭像的成員隨機分配頭像
      if (message.data.memberList) {
        message.data.memberList = message.data.memberList.map(member => ({
          ...member,
          avatar: member.avatar || avatars[Math.floor(Math.random() * avatars.length)]
        }))
      }
      
      // 豐富成員資料，加入群組資訊（註解掉 group 相關功能）
      // if (message.data.memberList) {
      //   message.data.memberList = enrichMembersWithGroup(message.data)
      // }
      
      pickupData.value = message.data
      
      // 如果遊戲已開始，立即更新戳洞板
      if (gameStarted.value) {
        allCandidatesCache.value = getPickCandidates()
        createPunchBoard(allCandidatesCache.value)
      }
    }

    // 生命週期
    onMounted(() => {
      // 初始化通信橋接器並監聽消息
      setupMessageListener()
      
      // 發送初始化訊息
      sendInitMessage()
      
      // // 發送窗口大小協議
      // messageBridge.postMessage({
      //   action: 'Window.Size',
      //   width: 1000,
      //   height: 800
      // })

      createFakePunchBoard()
    })

    onUnmounted(() => {
      // 清除所有顏色動畫間隔
      colorIntervals.forEach(interval => clearInterval(interval))
      colorIntervals = []
      
      // 停止所有音效並重置
      const audioElements = [punchSound.value, winSound.value, animationMusic.value]
      audioElements.forEach(audio => {
        if (audio && !audio.paused) {
          audio.pause()
          audio.currentTime = 0
        }
      })
      
      // 重置遊戲狀態
      showStartOverlay.value = true
      showCardResultPopup.value = false
      gameStarted.value = false
      isAnimationMusicPlaying.value = false
      selectedItem.value = null
      displayItems.value = []
      punchedItems.value = []
      punchingItems.value = []
      allCandidatesCache.value = []
      
      // 清空數據
      pickupData.value = {
        pickupType: "Client",
        memberList: []
      }
      
      console.log('HTPunchBoardPlay 資源已清理')
    })

    return {
      showStartOverlay,
      showCardResultPopup,
      selectedItem,
      displayItems,
      punchedItems,
      punchingItems,
      pickupData,
      punchBoard,
      punchSound,
      winSound,
      animationMusic,
      startGame,
      punchHole,
      closeCardResult,
      resetGame,
      goToSettings
    }
  }
}
</script>

<style lang="less">


.punchboard-container {
  width: 100%;
  margin: 0 auto;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  font-family: 'Microsoft JhengHei', 'PingFang TC', sans-serif;
  background: linear-gradient(to bottom, #2c5364 0%, #203a43 30%, #0f2027 100%);
  line-height: 1.6;
  color: #333;
  min-height: 100vh;

  /* 基本樣式設定 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

  /* 開始蓋板樣式 */
  .start-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1001;
    backdrop-filter: blur(5px);

    &.hidden {
      display: none;
    }

    .start-button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
      border: none;
      border-radius: 50%;
      width: 200px;
      height: 200px;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
      animation: pulse-start 2s infinite;

      &:hover {
        transform: scale(1.1);
        box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
      }

      &:active {
        transform: scale(0.95);
      }

      .play-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;

        svg {
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
        }
      }
    }

    .setting-button-overlay {
      position: fixed;
      top: 20px;
      right: 20px;
      background-color: #d1e8ff;
      border: 1px solid transparent;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1002;

      &:hover {
        background-color: #b8dbff;
      }

      .setting-icon {
        width: 40px;
        height: 40px;
        
        svg {
          width: 100%;
          height: 100%;
          * {
            fill: black !important;
          }
        }
      }
    }
  }

  /* 卡片結果彈窗樣式 */
  .card-result-popup {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;

    &.show {
      opacity: 1;
      visibility: visible;

      .card-result-content {
        transform: scale(1);
      }
    }

    .card-result-content {
      position: relative;
      top: -40px;
      width: auto;
      min-width: 200px;
      max-width: 90%;
      background-color: transparent;
      padding: 30px;
      transform: scale(0.8);
      transition: transform 0.3s ease;
      overflow: visible;
    }
  }

  .close-button {
    position: absolute;
    top: 45px;
    right: 45px;
    width: 30px;
    height: 30px;
    background-color: gray;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 10;
    transition: background-color 0.2s ease;

    svg {
      width: 20px;
      height: 20px;
      color: white;
    }
  }



  .result-card {
    position: relative;
    width: auto;
    min-width: 200px;
    height: 300px;
    overflow: visible;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #d9d9d9;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;

    .result-avatar {
      width: 200px;
      height: 200px;
      object-fit: contain;
      padding: 20px;
      padding-bottom: 0px;
    }

    .result-seat-id {
      position: absolute;
      top: 10px;
      left: 10px;
      background: #6200ea;
      color: white;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 14px;
      border: 2px solid white;
      z-index: 3;
    }

    .result-card-name {
      font-size: 60px;
      font-weight: bold;
      color: blue;
      text-align: center;
      margin-top: -20px;
      width: auto;
      padding: 10px;
      white-space: nowrap;
      min-width: max-content;
    }

    .result-card-group {
      font-size: 20px;
      font-weight: bold;
      color: brown;
      background-color: rgb(232, 232, 232);
      border-radius: 12px;
      text-align: center;
      margin-top: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 250px;
      padding: 5px;
    }
  }

  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1200px;
    padding: 20px 40px;
    z-index: 1;
    padding-top: 80px;

    .punch-board {
      position: relative;
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 15px;
      width: 100%;
      max-width: 100vw;
      padding: 20px;
      background-color: #8B4513;
      border-radius: 15px;
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
      margin-top: 0px;
      z-index: 2;

      .punch-hole {
        position: relative;
        width: 100%;
        height: 150px;
        cursor: pointer;
        border-radius: 10px;
        overflow: hidden;

        .punch-cover {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2;
          box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
          border: 2px solid #000;
          overflow: hidden;
          transition: transform 0.3s ease;

          &::before {
            content: "?";
            font-size: 90px;
            font-weight: bold;
            color: white;
            position: relative;
            z-index: 3;
            display: block;
          }

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 70%;
            height: 70%;
            background: radial-gradient(circle, rgba(0,0,0,0.2) 0%, transparent 70%);
            border-radius: 50%;
            transform: translate(-50%, -50%);
            z-index: 1;
          }
        }

        &.punched .punch-cover::before {
          opacity: 0;
        }

        .punch-content {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #ccc;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          z-index: 1;
          border: 3px solid red;
          overflow: hidden;

          .avatar {
            width: 100%;
            height: 100%;
            object-fit: contain;
            position: absolute;
            padding: 10px;
            top: 0;
            left: 0;
            z-index: 1;
            box-shadow: none !important;
            border-radius: 0 !important;
          }
        }

        &.punched .punch-content {
          z-index: 3;
          box-shadow: 0 0 15px rgba(255, 215, 0, 0.7);
        }

        .seat-id {
          position: absolute;
          top: 5px;
          left: 5px;
          background: #6200ea;
          color: white;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 16px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          border: 2px solid white;
          z-index: 3;
        }

        .result-info {
          position: absolute;
          bottom: 0px;
          left: 50%;
          transform: translateX(-50%);
          padding: 3px 0;
          text-align: center;
          z-index: 2;
          line-height: 1;

          .result-group {
            font-size: 14px;
            color: red;
            padding: 1px 8px;
            border-radius: 12px;
            background-color: rgba(255, 255, 255, 0.7);
            font-weight: bold;
            display: block;
            margin-bottom: 4px;
            max-width: 80px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .result-name {
            font-size: 14px;
            font-weight: bold;
            color: blue;
            display: block;
            margin-top: 0;
            max-width: 80px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .punch-effect {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0;
          height: 0;
          background: radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,215,0,0.8) 50%, rgba(255,165,0,0.6) 100%);
          border-radius: 50%;
          transform: translate(-50%, -50%);
          z-index: 5;
          pointer-events: none;
          box-shadow: 0 0 30px rgba(255, 255, 255, 0.9);
        }

        &.punching {
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: radial-gradient(circle at center, transparent 30%, rgba(255, 165, 0, 0.3) 70%);
            z-index: 5;
            animation: shockwave 0.5s ease-out forwards;
            border-radius: 10px;
          }

          .punch-effect {
            animation: punchAnimation 0.4s cubic-bezier(0.22, 0.61, 0.36, 1) forwards;
          }
        }
      }
    }
  }

  /* 右上角按鈕群組 */
  .top-right-buttons {
    position: absolute;
    top: 15px;
    right: 55px;
    display: flex;
    gap: 8px;
    z-index: 1000;

    .top-button {
      background-color: #d1e8ff;
      border: 1px solid transparent;
      border-radius: 5px;
      width: 50px;
      height: 50px;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;

      &:hover {
        background-color: #b8dbff;
      }

      /* 統一所有 SVG 圖標大小和顏色 */
      svg {
        width: 28px ;
        height: 28px;
        
        * {
          fill: #000000 !important;
        }
      }
      &.reset-button {
        .reset-icon {
          width: 24px;
          height: 24px;
        }
      }

      &.setting-button {
        .setting-icon {
          width: 32px;
          height: 32px;

          svg {
            width: 32px !important;
            height: 32px !important;

            * {
              fill: #000000 !important;
            }
          }
        }
      }
    }
  }

  /* 裂紋效果 */
  .crack {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.8);
    transform-origin: center;
    z-index: 4;
    opacity: 0;
  }

  /* 紙屑效果 */
  .confetti {
    position: absolute;
    width: 10px;
    height: 10px;
    z-index: 4;
    opacity: 0;
    border-radius: 2px;

    &.confetti-1 { background-color: #9bff61; }
    &.confetti-2 { background-color: #58ffd2; }
    &.confetti-3 { background-color: #ff8983; }
    &.confetti-4 { background-color: #fffa6f; }
  }
  /* Keyframes */
@keyframes pulse-start {
  0% {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), 0 0 0 0 rgba(255, 107, 107, 0.7);
  }
  70% {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), 0 0 0 20px rgba(255, 107, 107, 0);
  }
  100% {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), 0 0 0 0 rgba(255, 107, 107, 0);
  }
}

@keyframes crackAnimation {
  0% {
    opacity: 1;
    width: 0;
    height: 2px;
  }
  100% {
    opacity: 0;
    width: 100%;
    height: 2px;
  }
}

@keyframes shockwave {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

@keyframes punchAnimation {
  0% {
    width: 0;
    height: 0;
    opacity: 1;
    transform: translate(-50%, -50%) scale(0.1);
  }
  50% {
    width: 150%;
    height: 150%;
    opacity: 0.9;
    transform: translate(-50%, -50%) scale(1.2);
  }
  100% {
    width: 200%;
    height: 200%;
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.5);
  }
}

@keyframes confettiAnimation {
  0% {
    transform: translate(0, 0) rotate(0deg) scale(1);
    opacity: 1;
  }
  25% {
    transform: translate(calc(var(--tx) * 0.3), calc(var(--ty) * 0.3)) rotate(calc(var(--rot) * 0.3)) scale(1.2);
    opacity: 0.9;
  }
  50% {
    transform: translate(calc(var(--tx) * 0.5), calc(var(--ty) * 0.5)) rotate(calc(var(--rot) * 0.5)) scale(1.4);
    opacity: 0.7;
  }
  100% {
    transform: translate(var(--tx), var(--ty)) rotate(var(--rot)) scale(0.5);
    opacity: 0;
  }
}
}
</style>